import { useTranslation } from 'react-i18next'
import { formatCurrency } from '../../../../domain/vos/format-currency'
import { CardInfoBox } from '../../../components/card-info-box'
import { LoadingCard } from '../../../components/loading-card'

type TotalSaleProps = {
  amount?: number
  isLoading: boolean
}

export const TotalSale = ({ isLoading, amount }: TotalSaleProps) => {
  const { t } = useTranslation()

  if (isLoading) {
    return <LoadingCard />
  }

  return (
    <CardInfoBox
      title={t('totalSale.title')}
      description={t('totalSale.description')}
      current={formatCurrency(amount ?? 0)}
    />
  )
}
